import React, { Component } from 'react'
import TextField from '@mui/material/TextField'

import FieldWrapper from '../FieldRowWrapper'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import RawHtml from 'stories/components/RawHtml'
import clsx from 'clsx'

import './long-text-input.css'

export default class LongTextInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false,
    }
  }

  onInputChange = (event) => {
    const { value } = event.target
    this.props.onChange(value)
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => {
    return this.props.value
  }

  render() {
    const {
      label = '',
      name = '',
      placeholder,
      required,
      touched,
      error,
      description,
      customized,
      disabled,
      enableCodeStyle,
      minRows = 3,
      ltr,
    } = this.props

    const classNames = {
      'formz-long-text-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }
    const inputProps = {
      name,
      value: this.getInputValue(),
      onChange: this.onInputChange,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
      disabled,
    }
    if (customized)
      return (
        <FieldRowWrapper
          className={classNames}
          error={error}
          touched={touched ? touched.toString() : undefined}
        >
          <label className="formz-field-and-label-holder">
            <div className="formz-input-title">
              {label} {required && '(*)'}
            </div>

            <RawHtml
              className="formz-field-description"
              content={description}
            />

            <textarea
              {...inputProps}
              className="formz-input-field"
              placeholder={placeholder}
            />
          </label>
        </FieldRowWrapper>
      )
    return (
      <FieldWrapper
        error={error}
        touched={touched ? touched.toString() : undefined}
        fullWidth={this.props.fullWidth}
      >
        <TextField
          {...inputProps}
          label={label || placeholder}
          error={Boolean(error)}
          multiline
          minRows={minRows}
          style={{ direction: ltr ? 'ltr' : 'inherit' }}
          className={clsx({ 'code-style': enableCodeStyle })}
        />
      </FieldWrapper>
    )
  }
}
